<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="fa fa-clock-o"></i> {{ $t('follow_ups_timeline') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="card-box">
            <form>
                <div class="row">
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix">
                        <label>{{ $t('date_range') }}</label>
                        <div class="input-daterange input-group">
                            <pml-date-picker v-model="filters.created_at_from"></pml-date-picker>
                            <span class="input-group-addon b-0">
                                <i class="fa fa-calendar"></i>
                            </span>
                            <pml-date-picker v-model="filters.created_at_to"></pml-date-picker>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix">
                        <label>{{ $t('consultant') }}</label>
                        <pml-select-members v-model="filters.member_id" :onlyActive="true"></pml-select-members>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix">
                        <label>{{ $t('access_ways') }}</label>
                        <pml-select v-model="filters.access_way_id" :options="accessWays"></pml-select>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix">
                        <label>{{ $t('segments') }}</label>
                        <pml-select v-model="filters.segment_id" :options="segments"></pml-select>
                    </div>
                    <div class="col-xs-12 m-b-15 clearfix" v-if="filters.show_log">
                        <pml-checkbox v-model="filters.show_log" :label="$t('show_follow_up_logs')"></pml-checkbox>
                    </div>
                </div>
                <hr class="m-t-0">
                <div class="clearfix">
                    <span class="btn btn-white pull-left" @click.prevent="clear()"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>
                    <button class="btn btn_green pull-right" @click.prevent="getTimeline()">
                        <span class="btn-label">
                            <i class="fa fa-search"></i>
                        </span>
                        {{ $t('filter') }}
                    </button>
                </div>
            </form>
        </div>
        <div class="bg_load_null">
            <div v-show="list.length || isLoading" class="card-box list_timeline p-15 p-t-50 space_left">
                <TimelineItem v-for="item in list" :item="item" :key="item.id"></TimelineItem>
                <PmlInfiniteLoading @infinite="infiniteHandler($event)" :ref="'infiniteLoading'" spinner="wavedots">
                    <span slot="no-more"></span>
                    <span slot="no-results"></span>
                    <span v-if="list.length === total && !isLoading" slot="spinner"></span>
                </PmlInfiniteLoading>
            </div>
            <div v-if="!list.length && !isLoading" class="text-center p-t-40"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</div>
        </div>
    </master-layout>
</template>

<script>
    import { getFollowUpsTimeline } from 'services/reports'
    import { isNull, isEmpty, isNil } from 'lodash'
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import PmlInfiniteLoading from 'vue-infinite-loading'
    import TimelineItem from './Item.vue'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'Timeline',
        components: { PmlInfiniteLoading, TimelineItem },
        data () {
            return {
                isLoading: false,
                list: [],
                total: 0,
                loading: {
                    page: 0,
                    paginate: 15
                },
                filters: {
                    created_at_from: null,
                    created_at_to: null,
                    show_log: false,
                    member_id: null,
                    access_way_id: null,
                    segment_id: null
                }
            }
        },
        metaInfo () {
            return {
                title: trans('timeline')
            }
        },
        computed: {
            ...mapGetters({
                segments: 'getSegments',
                accessWays: 'getAccessWays',
                member: 'getMember'
            })
        },
        mounted () {
            this.initFilters()
        },
        methods: {
            initFilters () {
                if (typeof this.$route.params.id !== 'undefined') {
                    this.filters = {
                        created_at_from: this.storeFormat(window.localStorage.getItem('pml_reports_follow_ups_created_at_from'), 'created_at_from'),
                        created_at_to: this.storeFormat(window.localStorage.getItem('pml_reports_follow_ups_created_at_to'), 'created_at_to'),
                        show_log: this.storeFormat(window.localStorage.getItem('pml_reports_follow_ups_show_log'), 'show_log'),
                        member_id: this.storeFormat(window.localStorage.getItem('pml_reports_follow_ups_member_id'), 'member_id'),
                        access_way_id: this.storeFormat(window.localStorage.getItem('pml_reports_follow_ups_access_way_id'), 'access_way_id'),
                        segment_id: this.storeFormat(window.localStorage.getItem('pml_reports_follow_ups_segment_id'), 'segment_id')
                    }
                    if (this.filters.member_id !== parseInt(this.$route.params.id))
                        this.filters.member_id = parseInt(this.$route.params.id)

                    this.getTimeline()
                } else if (window.localStorage.getItem('pml_reports_follow_ups_show_all') === 'showAll') {
                    window.localStorage.removeItem('pml_reports_follow_ups_show_all')
                    this.filters = {
                        created_at_from: null,
                        created_at_to: null,
                        show_log: false,
                        member_id: this.member.id,
                        access_way_id: null,
                        segment_id: null
                    }

                    this.getTimeline()
                } else {
                    this.clear()
                }
            },
            updateStorage () {
                window.localStorage.setItem('pml_reports_follow_ups_created_at_from', isNil(this.filters.created_at_from) ? '' : this.filters.created_at_from)
                window.localStorage.setItem('pml_reports_follow_ups_created_at_to', isNil(this.filters.created_at_to) ? '' : this.filters.created_at_to)
                window.localStorage.setItem('pml_reports_follow_ups_show_log', this.filters.show_log ? '1' : '0')
                window.localStorage.setItem('pml_reports_follow_ups_member_id', isNil(this.filters.member_id) ? '' : this.filters.member_id)
                window.localStorage.setItem('pml_reports_follow_ups_access_way_id', isNil(this.filters.access_way_id) ? '' : this.filters.access_way_id)
                window.localStorage.setItem('pml_reports_follow_ups_segment_id', isNil(this.filters.segment_id) ? '' : this.filters.segment_id)
            },
            getTimeline ($state = null) {
                if (isNull($state)) {
                    this.isLoading = true
                    this.list = []
                    this.total = 0
                    this.loading.page = 0
                    this.updateStorage()
                    this.$nextTick(() => this.$refs['infiniteLoading'].$emit('$InfiniteLoading:reset'))
                } else {
                    getFollowUpsTimeline({...this.filters, page: this.loading.page + 1, paginate: this.loading.paginate})
                        .then((response) => {
                            this.list.push(...response.data.data)
                            this.total = response.data.total
                            this.loading.page = response.data.current_page

                            $state.loaded()
                            if (this.list.length === this.total)
                                $state.complete()
                        })
                        .catch((e) => { console.log(e) })
                        .then(() => { this.isLoading = false })
                }
            },
            storeFormat (val, type) {
                if (type === 'show_log')
                    return val === 1
                if ((isNil(val) || isEmpty(val)) && type === 'created_at_from')
                    return moment().subtract(14, 'days').format('DD/MM/YYYY')
                if ((isNil(val) || isEmpty(val)) && type === 'created_at_to')
                    return moment().add(1, 'days').format('DD/MM/YYYY')
                if ((isNil(val) || isEmpty(val)) && (type === 'member_id' || type === 'access_way_id' || type === 'segment_id'))
                    return null
                if (type === 'member_id' || type === 'access_way_id' || type === 'segment_id')
                    return parseInt(val)
                if (type === 'created_at_from' || type === 'created_at_to')
                    return moment(val, 'DD/MM/YYYY').format('DD/MM/YYYY')
            },
            infiniteHandler ($state) {
                setTimeout(() => {
                    this.getTimeline($state)
                }, 1000)
            },
            clear () {
                this.filters = {
                    created_at_from: moment().subtract(14, 'days').format('DD/MM/YYYY'),
                    created_at_to: moment().add(1, 'days').format('DD/MM/YYYY'),
                    show_log: false,
                    member_id: this.member.is_admin ? null : this.member.id,
                    access_way_id: null,
                    segment_id: null
                }
                this.getTimeline()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/follow-ups/components/Timeline.vue